export const environment = {
    production: false,
    apiUrl: 'https://api.adm.homologacao.imap.org.br/api',
    defaultSaiUrl: 'http://sai.homologacao-v1.imap.org.br',
    defaultTransparenciaUrl: 'https://transparencia.homologacao-v1.imap.org.br'
  };